export default __webpack_public_path__ + "static/media/mosaic-logo-text-black.0d20e4a1.svg";